import React from "react";
import "./Introduction.css";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { ThemeContext } from "../../Context/theme";
import profilePic from "../../assets/S-logo.png";


export const Introduction = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <section id="#about">
        <div className="section" data-aos="fade-right">
          <h2 className="section__title">
            About <span className="different">Me</span>
          </h2>
          <div className={"introduction " + themename}>
            <div className="introduction_logocontainer">
              <img src="https://avatars.githubusercontent.com/u/82110100?s=400&u=1154dbe3a938666d90a7089b1502f5a7116e8515&v=4" alt="Images" />
            </div>
            <div className="introduction_datacontainer">
              <h4>
                Hi Everyone, My name is{" "}
                <span className="different">Hemanth Kumar </span> and I am from{" "}
                <span className="different">
                  {" "}
                  Vizag, Andhra Pradesh (India)
                </span>
                . I have completed my graduation in BTech (Mech. Engineering)
                from{" "}
                <span className="different">
                  VIGNAN's INSTITUTE OF INFORMATION TECHNOLOGY, Duvvada (AP)
                </span>
                . Then I started acquiring full stack development by{" "}
                <span className="different">Wipro </span> as an internship
                for 4 months.
              </h4>
              <h4>Terms That can describe me apart form Coding :</h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Gaming{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Badminton Enthusiast{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Freelancer{" "}
              </h4>
              <h4 className="different">
                <span className="icons">
                  <ExitToAppIcon />
                </span>
                Poet{" "}
              </h4>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
